import React from 'react';

import { connect } from 'react-redux';
import { BrowserWarning } from 'components';

const BrowserWarningContainer = props => <BrowserWarning {...props} />;

const mapStateToProps = () => {
  // eslint-disable-next-line spaced-comment
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  return {
    isIE,
  };
};

export default connect(mapStateToProps)(BrowserWarningContainer);



// WEBPACK FOOTER //
// ./src/containers/BrowserWarning.js